document.addEventListener('DOMContentLoaded',function(){
    //=============== SHOW MORE ===============
    $(".key-features-expand-btn").click(function(){
        let isOpen = $(this).attr("data-open")
        if(isOpen == 'false'){
        $(this).attr("data-open","true").addClass("isOpenBtn")
        
        $(this).siblings(".product-info__description .prose").addClass("product_features_show")
        }else{
        $(this).attr("data-open","false").removeClass("isOpenBtn")
        $(this).siblings(".product-info__description .prose").removeClass("product_features_show")
        }
    })


    // 信任模块-国家区分展示
    async function updateTextByLocation() {
        const textContainer = document.getElementById('cs-dynamic-text');
        try {
            const response = await fetch('https://ipapi.co/json/');
            if (!response.ok) throw new Error('Network response was not ok');
            
            const data = await response.json();
            const countryCode = data.country;
            if (countryCode === 'US') {
                textContainer.innerText = 'United States';
            } else {
                textContainer.innerText = 'HK';
            }
        } catch (error) {
            console.error('获取 IP 归属地失败:', error);
            // 接口挂掉或网络错误时的兜底方案（Fallback）
            textContainer.innerText = 'HK';
        }
    }
    // updateTextByLocation();


    // In the box- tab切换
    var $section = $('.product-InTheBox-section');
    $section.find('.itb-tab-btn').on('click', function() {
        var $this = $(this);
        var tabId = $this.attr('data-tab'); // 获取 data-tab 属性值

        $section.find('.itb-tab-btn').removeClass('active');
        $this.addClass('active');

        $section.find('.itb-content-grid').removeClass('active');
        $section.find('#content-' + tabId).addClass('active');
    });


    //=============== Which Version is right for you? ===============

    let scrollPos = 0;
    function openModal() {
        scrollPos = window.pageYOffset || document.documentElement.scrollTop;
        document.body.style.top = `-${scrollPos}px`;
        document.body.classList.add('modal-open');
    }

    function closeModal() {
        document.body.classList.remove('modal-open');
        document.body.style.top = '';
        window.scrollTo(0, scrollPos);
        // 重置 header 的滚动追踪状态，防止弹框关闭后导航被误隐藏
        const header = document.querySelector('store-header[hide-on-scroll]');
        if (header) {
            header._lastScrollTop = scrollPos;
            header._accumulatedScroll = 0;
        }
    }
    
    const $comparisonModal = $('.product-info__version-table');
    $('.product-info__version-box').on('click', function() {
        $comparisonModal.fadeIn(300);
        openModal()
    });
    $('.VTmodal-close-icon').on('click', function() {
        $comparisonModal.fadeOut(300);
        closeModal()
    });
    // 点击弹窗外部遮罩层也可以关闭
    $comparisonModal.on('click', function(e) {
        if ($(e.target).is('.product-info__version-table')) {
            $(this).fadeOut(300);
            closeModal()
        }
    });



    //=============== buy me ===============
    if($('.product-trust-container').length>0){
        let elementTopfixed = $('.product-trust-container').offset().top
        $(window).on('scroll', function() {
            var windowTop = $(window).scrollTop(); 
            if (window.screen.width > 1024) {
                if(windowTop >= elementTopfixed+300){
                    $(".buyMe").show()
                }
                if(windowTop < elementTopfixed){
                    $(".buyMe").hide()
                }
            }else{
                if(windowTop >= elementTopfixed){
                    $(".buyMe").show()
                }
                if(windowTop < elementTopfixed){
                    $(".buyMe").hide()
                }
            }
        });
    }
    // buyMe-按钮点击
    $(".buyMe .cs_addToCart").click(function(){
        var $cartBtn = $(this);
        // 1. 防止重复点击
        $cartBtn.prop('disabled', true);
        var originalText = $cartBtn.text();
        $cartBtn.text('Loading... ');
        setTimeout(function() {
            $cartBtn.text(originalText).prop('disabled', false);
        }, 2000);
        
        $(".product-info__buy-buttons .button--secondary").click()
    })
    $(".buyMe_buyNow button").click(function(){
        $(".product-info__buy-buttons .shopify-payment-button__button").click()
    })

    // 初始化矫正价格
    currentPriceFun()
    
    // product form 变体切换改变buy me价格及变体
    function currentPriceFun(types){
        setTimeout(()=>{
            let getCurrentPrice = $(".product-info__price price-list sale-price").attr("data-price")
            $(".buyMe sale-price").text(getCurrentPrice)
        },600)
    }

    document.addEventListener('change', function(event) {
        if (event.target.matches('input[type="radio"].variant-picker__option-radio')) {
            let currentVariant = event.target.getAttribute('data-variant-id')
            $(".buyMe .product-variant-select").val(`${currentVariant}`)
            currentPriceFun()
        }
    });



    // buy me变体切换
     $(".buyMe .product-variant-select").on('change', function() {
        let changeVariant = $(`.product-info__variant-picker .variant-picker__option-values input[data-variant-id=${$(this).val()}]`)
        changeVariant.click()
        currentPriceFun()
    });
})


 